import { render, staticRenderFns } from "./LaboratoryIndicatorsDictionary.vue?vue&type=template&id=7ec607ac&lang=pug&"
import script from "./LaboratoryIndicatorsDictionary.vue?vue&type=script&lang=js&"
export * from "./LaboratoryIndicatorsDictionary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports